export default "__VITE_ASSET__CAPSOE1J__"